import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';
import RadarChartResume from '@core/components/radarchart/RadarChartReport';
import RelatedJobCourses from 'components/pages/jobs/jobdetails/relatedjobcourses/RelatedJobCourses';
import CustomCircularProgress from '@core/components/customcircularprogress/CustomCircularProgress';

import classes from './JobSkillInsight.module.scss';



const JobSkillInsight = ({ skill_profile, skillInsights, relatedCourses = null, job_match_score = null }) => {
    if (!skill_profile) return null;
    return (
        <div className={classes['wrapper']}>
            {job_match_score ? (
                <div className='d-flex justify-content-center align-items-center gap-3'>
                    <CustomCircularProgress progressCount={job_match_score} size={64} />
                    <h3 className='m-0'>
                        You match {job_match_score}% of this role's requirements
                    </h3>
                </div>
            ) : (
                <h3 className='d-flex justify-content-center align-items-center gap-3 '>
                    How you match this role
                </h3>
            )
            }

            <div className='row'>
                <div className='col-12 col-xl-6 d-flex flex-column align-items-center justify-content-center'>
                    <div className={classes['chart-wrapper']}>
                        <RadarChartResume chartData={skill_profile} isSmall={true} imageSize='140' />
                        <h5>Job skills requirement</h5>
                    </div>
                </div>
                <div className='col-12 col-xl-6 d-flex flex-column align-items-center justify-content-center gap-3'>
                    {skillInsights.skill_insights ? (
                        <div className={classes['chart-wrapper']}>
                            <RadarChartResume chartData={skillInsights.skill_insights} isSmall={true} imageSize='140' />
                            <h5>Your skill insights</h5>
                        </div>
                    ) : (
                        <div className={classes['empty-state']}>
                            <h4>Do you have what this role needs?</h4>
                            <p>
                                Upload your CV and see exactly how your skills compare to this job — and which ones to build to close the gap.
                            </p>
                            <LinkButton to='/profile/my-resume' kind='primary-color'>
                                See how I compare
                            </LinkButton>
                        </div>
                    )}
                </div>
            </div>
            {
                relatedCourses && relatedCourses.length > 0 && (
                    <>
                        <div className={classes['divider']}></div>
                        <RelatedJobCourses data={relatedCourses} />
                    </>
                )
            }
        </div >
    );
};

export default JobSkillInsight;